import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mobileNumber:
    JSON.parse(window.localStorage.getItem("user_phone_number")) || "",
  isUserActive: JSON.parse(window.localStorage.getItem("isActive")) || false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
      window.localStorage.setItem(
        "user_phone_number",
        JSON.stringify(action.payload)
      );
    },
    setUserActive: (state, action) => {
      state.isUserActive = action.payload;
      window.localStorage.setItem("isActive", JSON.stringify(action.payload));
    },
  },
});

const userReducer = userSlice.reducer;

export const { setMobileNumber, setUserActive } = userSlice.actions;

export default userReducer;
